import type { ComponentType } from 'react';
import { createContext } from 'react';

import type { GoogleMaps } from '@shared/types/client-side-params';

import displayName from '@shared/utils-frontend/display-name';

type ContextProps = {
  googleMaps: GoogleMaps;
};

// @ts-expect-error missing properties
const GoogleMapsContext = createContext<GoogleMaps>({});

const withGoogleMaps = <P extends ContextProps>(
  Component: ComponentType<P>,
) => {
  const component = (props: Omit<P, 'googleMaps'>) => (
    <GoogleMapsContext.Consumer>
      {(googleMaps: GoogleMaps) => (
        // @ts-expect-error we expect that googleMaps can be overwritten in the unit tests
        <Component googleMaps={googleMaps} {...(props as P)} />
      )}
    </GoogleMapsContext.Consumer>
  );

  component.displayName = displayName(Component);

  return component;
};

export default GoogleMapsContext;
export { withGoogleMaps };
